var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"whiteBg"},[_c('info')],1),_c('div',{staticClass:"line"}),_c('div',{staticClass:"whiteBg"},[_c('companyInfo')],1),_c('div',{staticClass:"line"}),_c('div',{staticClass:"whiteBg"},[_c('replenishInfo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }